"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitlistItemValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
exports.waitlistItemValidationSchema = (0, yup_1.object)().shape({
    account: yup_rules_eth_1.addressValidationSchema,
    listId: yup_rules_1.dbIdValidationSchema,
});
//# sourceMappingURL=validation.js.map